import { useMemo } from 'react';
import type { MouseEvent as ReactMouseEvent } from 'react';
import { useStoreApi } from '../../store';
import type { ElementHandlers } from '../../store';
import { toEventNode } from './eventNode';

type NodeHandlerName = 'onNodeClick' | 'onNodeDoubleClick' | 'onNodeMouseEnter' | 'onNodeContextMenu';

/** React mouse handlers that forward to the app's v11 node callbacks with the current node. */
export const useNodeEvents = (id: string) => {
  const store = useStoreApi();
  return useMemo(() => {
    const forward = (name: NodeHandlerName) => (event: ReactMouseEvent) => {
      const { elementHandlers, nodeLookup } = store.getState();
      const handler: ElementHandlers[NodeHandlerName] = elementHandlers[name];
      const internal = nodeLookup.get(id);
      if (handler && internal) handler(event.nativeEvent, toEventNode(internal));
    };
    return {
      onClick: forward('onNodeClick'),
      onDoubleClick: forward('onNodeDoubleClick'),
      onMouseEnter: forward('onNodeMouseEnter'),
      onContextMenu: forward('onNodeContextMenu'),
    };
  }, [store, id]);
};
